<template>
  <lay-row space="10" >
    <lay-col md="8">
      <lay-panel style="padding: 10px; ">
        <lay-field title="自动审核配置">
 
 
          <lay-form :model="confingIfon"  pane="true" > 
            <lay-form-item label="自动审核" prop="automatic" mode="inline" style=" display: block; !important">
                  <lay-switch v-model="confingIfon.automatic" style=" width: 0px !important"></lay-switch>
                </lay-form-item>
 
            <lay-form-item label="官方担保" prop="guarantee" mode="inline" style=" display: block;">
              <lay-switch v-model="confingIfon.guarantee" style="width: 0px !important"></lay-switch>
            </lay-form-item>   

            <lay-form-item label="标题" prop="titleDay" tips="">
              <lay-input v-model="confingIfon.titleDay" placeholder="标题多少天之内不能重复"></lay-input>
            </lay-form-item>

            <lay-form-item label="图片" prop="pictureDay" tips="">
              <lay-input v-model="confingIfon.pictureDay" placeholder="图片多少天之内不能重复"></lay-input>
            </lay-form-item>

            <lay-form-item label="简介" prop="summaryDay" tips="">
              <lay-input v-model="confingIfon.summaryDay" placeholder="简介多少天之内不能重复"></lay-input>
            </lay-form-item> 
            <lay-form-item style="text-align: center;">
              <lay-button type="primary" @click="submitConfig">提交</lay-button>
            </lay-form-item>
          </lay-form>


        </lay-field>
      </lay-panel>
    </lay-col>
    <lay-col md="16">
      <lay-panel style="padding: 10px">
        <lay-field title="平台节点配置"> 
          <div style="margin-bottom: 10px;text-align: left;">
          <lay-button size="sm" @click="changeVisible11" type="primary">新增</lay-button>
        </div>

          <lay-table  :height="'100%'" :columns="columns"  :data-source="dataSource"
          v-model:selected-keys="selectedKeys"> 
          <template v-slot:operator="{ row }">
            <lay-button size="xs" type="primary" @click="updatePlatform(row)">编辑</lay-button>
            <lay-button size="xs" type="danger" @click="deletePlatform(row)">删除</lay-button>
          </template>
        </lay-table>
        </lay-field> 
      </lay-panel>
    </lay-col>
  </lay-row>



  <lay-layer v-model="visible11" :shade="false" :area="['600px', '800px']" :btn="action11" title="添加平台/修改平台">
    <div style="padding: 20px;">
      <lay-form :model="platform" ref="layFormRef11" >
          <lay-form-item label="平台名字" prop="name">
              <lay-input v-model="platform.name"></lay-input>
            </lay-form-item>

            <lay-form-item label="logo地址：" prop="logo">
              <lay-input v-model="platform.logo"></lay-input>
            </lay-form-item>   

            <lay-form-item label="图片地址：" prop="picture">
              <lay-input v-model="platform.picture"></lay-input>
            </lay-form-item>   
            <lay-form-item label="图片水印：" prop="watermark">
              <lay-input v-model="platform.watermark"></lay-input>
            </lay-form-item>

            <lay-form-item label="单文件大小：" prop="oneUploadSize">
              <lay-input v-model="platform.oneUploadSize"></lay-input>
            </lay-form-item>

            <lay-form-item label="每次多少张：" prop="howManySheets">
              <lay-input v-model="platform.howManySheets"></lay-input>
            </lay-form-item>

            <lay-form-item label="每天发布数量：" prop="releasesNum">
              <lay-input v-model="platform.releasesNum"></lay-input>
            </lay-form-item>

            <lay-form-item label="飞机频道：" prop="airplane">
              <lay-input v-model="platform.airplane"></lay-input>
            </lay-form-item>

            <lay-form-item label="TG客服：" prop="ca">
              <lay-input v-model="platform.ca"></lay-input>
            </lay-form-item>
 
            <lay-form-item label="公告：" prop="announcement">
              <lay-input v-model="platform.announcement"></lay-input>
            </lay-form-item>
  
     
      </lay-form>
    </div>
  </lay-layer>

</template>

<script  lang="ts" setup>
import { ref, reactive } from 'vue'
import { layer } from '@layui/layer-vue'
import { addPlatform,allPlatform,delPlatform,addSysConfig,getSysConfig} from '../../api'

const visible11 = ref(false);

const current1 = ref("1")
const selectedKeys = ref([]);

const dataSource = ref([]);

const page = reactive({ current: 1, limit: 10, total: 0 });

const columns = ref([
  { title: "平台名称", key: "name", align: "center" },
  { title: "appLogo", key: "logo", align: "center"},
  { title: "状态", key: "state", align: "center" },
  { title: "图片域名", key: "picture", align: "center" }, 
  { title: "图片水印", key: "watermark", align: "center"  },
  { title: "单文件大小", key: "oneUploadSize", align: "center" },
  { title: "每次多少张", key: "howManySheets", align: "center" },
  { title: "发布数量", key: "releasesNum", align: "center" },
  { title: "飞机频道", key: "airplane", align: "center" },
  { title: "TG客服", key: "ca", align: "center" },
  { title: "公告", key: "announcement", align: "center" }, 
  { title: "添加时间", key: "addTime", align: "center" },
  { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
]);


const getAllPlatform = () => {
  var data = { "page": page.current, "limit": page.limit};
  allPlatform(data).then((res: any) => {
    if (res != "" && res.code == 0) {
      dataSource.value = res.data;
      page.total = res.count;
    } else {
      dataSource.value = [];
      page.total = 0;
    }
  })
}

getAllPlatform();

 


const platform = reactive({
  id:0,
  mark: "",
  name: "",
  state: 1,
  announcement:"",
  picture:"",
  logo:"",
  watermark:"",
  oneUploadSize:0,
  howManySheets:0,
  releasesNum:0,
  airplane:"", 
  ca:""
 

})

const changeVisible11 = () => {
  platform.id=0,
  platform.mark="",
  platform.name="",
  platform.state= 1, 
  platform.announcement="",
  platform.picture="",
  platform.logo="",
  platform.watermark="",
  platform.oneUploadSize=0,
  platform.howManySheets=0,
  platform.releasesNum=0,
  platform.airplane="",
  platform.ca="", 
  visible11.value = !visible11.value;
}

const updatePlatform = (row: any) => {
  platform.id=row.id,
  platform.mark=row.mark,
  platform.name=row.name,
  platform.state= row.state,   
  platform.announcement=row.announcement,
  platform.picture=row.picture,
  platform.logo=row.logo,
  platform.watermark=row.watermark,
  platform.oneUploadSize=row.oneUploadSize,
  platform.howManySheets=row.howManySheets,
  platform.releasesNum=row.releasesNum,
  platform.airplane=row.airplane,
  platform.ca=row.ca, 
  visible11.value = !visible11.value;
}


const action11 = ref([
  {
    text: "确认",
    callback: () => {
      addPlatform(JSON.stringify(platform)).then((res: any) => {
        if (res != "" && res.code == 0) {
          getAllPlatform();
          visible11.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })
    }
  },
  {
    text: "取消",
    callback: () => {
      visible11.value = false; 
    }
  }
])



 

const deletePlatform=(row:any,)=>{
  var data={'id':row.id} 
  delPlatform(JSON.stringify(data)).then((res: any) => {
        if (res != "" && res.code == 0) {
          getAllPlatform();
          visible11.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })

}




const submitConfig=()=>{
     addSysConfig(JSON.stringify(confingIfon)).then((res: any) => {
        if (res != "" && res.code == 0) { 
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })

}





const confingIfon = reactive({
  automatic: true,
  guarantee: false,
  titleDay: "",
  pictureDay: "",
  summaryDay: "", 
})
 




const getAllSysConfig=()=>{
  getSysConfig().then((res: any) => {
        if (res != "" && res.code == 0) { 
          confingIfon.automatic=res.data.automatic
          confingIfon.guarantee=res.data.guarantee
          confingIfon.titleDay=res.data.titleDay
          confingIfon.pictureDay=res.data.pictureDay
          confingIfon.summaryDay=res.data.summaryDay 
        }
      })

}

getAllSysConfig()




 
 
</script>

<style scoped>

.layui-form-item .layui-input-inline{
  width: 0px;
}
</style>

